export enum EndpointsSendOtpTokenizeQueryKeys {
  SendOtp = '/retry/otp',
}
